<script>
import { MapGender } from "@/common/util";

export default {
  data() {
    return {
      formInline: {
        organizationId: "",
        organizationName: "",
        status: "",
        county: "",
        city: "",
        province: ""
      },
      tableData: [],
      textInputArray: [
        // {
        //   label: "工号",
        //   keyName: "staffId"
        // },
        {
          label: "视觉训练师姓名",
          keyName: "name"
        },
        {
          label: "手机号",
          keyName: "phone"
        }
      ],
      searchFormData: {
        staffId: "",
        name: "",
        phone: ""
      },
      defaultValue: {},
      totalElements: 0
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      let params = {};
      for (let key in this.searchFormData) {
        if (this.searchFormData[key]) {
          params[key] = this.searchFormData[key];
        }
      }
      let data = await this.$http.getGroupOptometristList(params);
      if (data && data.content) {
        let newTableData = [];
        this.totalElements = data.totalElements;

        data.content.forEach(item => {
          newTableData.push({
            id: item.content.id,
            staffId: item.content.staffId,
            name: item.content.name,
            phone: item.content.phone,
            gender: MapGender(item.content.gender),
            managementAreaNames:
              item.managementAreaNames && item.managementAreaNames.length > 0
                ? item.managementAreaNames.join(",")
                : "--"
          });
        });
        this.tableData = newTableData;
      }
    },
    onClick(row) {
      console.log("click row!", row);
      this.$router.push({
        path: `${this.$route.path}/visionDetail/${row.id}`
      });
    },
    handleClose(done) {
      this.dialogVisible = false;
    },
    onSearch(data) {
      this.searchFormData = data;
      this.loadData();
    }
  }
};
</script>
<template>
  <div class="visionManagementIndex">
    <searchForm class="searchForm" showSearch @onSearch="onSearch" :textInputArray="textInputArray" />
    <div class="statistics">
      <i class="el-icon-info totalResult"></i>
      查询结果：
      <span class="totalResult">{{totalElements}}</span> 个
    </div>
    <el-table
      :data="tableData"
      class="accountTableOptometrist"
      @row-click="onClick"
      :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
      :cell-style="{'padding-left': '5px'}"
    >
      <!-- <el-table-column prop="staffId" align="left" label="工号" width="180"></el-table-column> -->
      <el-table-column prop="name" align="left" label="视觉训练师姓名" width="180"></el-table-column>
      <el-table-column prop="gender" align="left" label="性别" width="180"></el-table-column>
      <el-table-column prop="phone" align="left" label="手机号" width="180"></el-table-column>
      <el-table-column prop="managementAreaNames" align="left" label="管理范围"></el-table-column>
    </el-table>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.visionManagementIndex {
  .searchForm {
    border: 1px;
    height: 70px;
    margin: 0 2%;
  }
  .statistics {
    float: right;
    margin-right: 30px;
    margin-top: -30px;
    margin-bottom: 10px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 22px;
    .totalResult {
      color: #00c1de;
    }
  }
  .labelStyle1 {
    margin: 20px 5px 10px;
    width: 200px;
  }

  .labelInput {
    width: 140px;
  }

  .searchButton {
    margin: 21px 5px;
  }

  .accountTableOptometrist {
    margin: 0px 2%;
    border: 1px;
    width: 96%;
    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
    th > .cell {
      font-weight: bold;
    }
  }

  .content {
    margin: 25px;
    background: rgba(249, 251, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(233, 236, 243, 1);
    padding: 29px 26px 29px 29px;
    color: #8c8c8c;

    p {
      margin-top: 7px;
    }

    .first {
      margin-top: 0px;
    }

    .type {
      padding-left: 20px;
    }

    .title {
      color: #00c1de;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/visionManagement/index.vue